module.exports = {
	common: {
		hello: 'Hello/ Hi',
	},
	navigator: {
		choose: 'Living In 9floor',
		filter: 'Search by Filter',
		map: 'Geographic Search',
		pauian: 'Pure Co-living',
		personalized: 'Recommend rooms ',
		ninthfloor: '9floor',
		about: 'About',
		media: 'Media',
		team: 'Team',
		contact: 'Contact',
		service: 'Service',
		space: 'Space Management',
		coliving: 'Coliving',
		journal: 'Journal',
		community: 'Community',
		news: 'News',
		note: 'Coliving',
		guide: 'Guide',
		member: 'Member',
		overview: 'Overview',
		setting: 'Settings',
		favorites: 'Favorites',
		propertyHistory: 'Property Viewing History',
		reservationHistory: 'Reservation History',
		onlineCommunity: 'Online Community',
		login: 'Login',
		logout: 'logout',
		register: 'Register',
		loginOrRegister: 'Login/ Register',
	},
	banner: {
		search: 'Search',
	},
	footer: {
		room: 'Living In 9floor',
		filter: 'Search by Filter',
		map: 'Geographic Search',
		pauian: 'Pure Co-living',
		personalized: 'Recommend rooms ',
		ninthfloor: '9floor',
		about: 'About',
		team: 'Team',
		space: 'Space Management',
		coliving: 'Coliving',
		community: 'Online Community',
		news: 'News',
		help: 'Help',
		how: 'How to Apply',
		FAQ: 'FAQ',
		contact: 'Contact',
		media: 'Media',
		moveIn: 'Terms of Service',
		privacy: 'Privacy Policy',
		termsofService: 'Terms of Service',
		sitemap: 'Sitemap',
		description: 'Description',
	},
	reservation: {
		MORNING: 'Morning',
		AFTERNOON: 'Afternoon',
		live: 'Live',
		phone: 'Phone',
		online: 'Virtual Viewing',
		checkin: 'Move-in',
		checkout: 'Check-out',
		interview_phone: 'Phone Interview ',
		interview_online: 'Online Interview',
		notValidText:
			'Uh oh. Your application materials are incomplete. Please complete all required fields.',
		notValidReserve:
			'Sorry, the time you selected has already been reserved. Please choose another time slot.',
		notReserveCheckinDate:
			"Can't find any time works for you? Please call 9floor team, our staff will fit you in. (Phone Number：+886 908959613)",
		notReserveCheckoutDate:
			"Can't find any time works for you? Please call 9floor team, our staff will fit you in. (Phone Number：+886 908959613)",
		checkinTime: 'Move-in Time',
		checkoutTime: 'Checkout Time',
		ViewTime: 'Property-viewing Time',
		checkinDescription: 'Move-in Description',
		checkoutDescription: 'Checkout Description',
		ViewMethod: 'Property-viewing Method',
		checkinResult:
			'We are looking forward to your move-in day. Please set aside about one hour for the check-in process. One of our staff members will briefly meet with you to answer questions about the space, tell you more about the roommates, and go over a few details that we hope will help equip you to get connected quickly.',
		checkoutResult:
			'For checkout, please leave your personal space in the same condition/appearance as check-in. Be sure to remove all personal belongings and trash. The checkout process will be conducted in accordance with the terms of stay. And last but not least, don’t forget to come back and visit everyone after moving out!',
		referenceNumber: 'Reference Number',
		address: 'Address',
		time: 'Time',
		phoneNumber: 'Phone Number',
		name: 'Name',
		cancelAnAppointment: 'Cancel an Appointment',
		changeAnAppointment: 'Change an Appointment',
		fillOutTheSurvey: 'Fill Out The Survey',
		successful: 'Reservation Successful',
		successDescription:
			'Thank you for your reservation. If availability changes and the listing or time slot is no longer available, we will contact you via email. If the change is within 24 hours of the appointment, we will notify you via phone. If you would like to cancel or change your reservation, please submit a request through the online member center.',
		viewReservation: 'View Details',
		backToRoom: 'Return to Listing',
		ninefloor: '9floor',
		calendar: 'Calendar',
		addToCalendar: 'Add to Calendar',
		gtm: 'GMT+8 time',
		next: 'Next',
		edit: 'Send',
		phoneDescription:
			'Phone Consultation: This service is currently only available for Taiwanese numbers. If you are in another country, please choose our virtual viewing option.',
		hangoutDescription:
			'Virtual Viewing: We use Google hangouts to facilitate online property viewings. After you register for an appointment, we will send a link to your registered email address.',
		hangout: 'Your Google Hangout ID',
		hangoutAccount: 'Hangout ID',
		chooseTypeValid: 'Please choose the way to view the properity.',
		checkPhoneAndHangoutAlert:
			'Please leave your phone number & google hangout account to make a reservation.',
		cancelSuccess:
			'Your reservation is cancelled. If you have any question, please contact our staff at +886 908959613 or <a class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a>.',
		updateSuccess:
			'Your reservation is updated. If you have any question, please contact our staff at +886 908959613 or <a  class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a>.',
		recordIsEmpty: 'There is no record for any current appointments.',
	},
	settings: {
		welcomeText:
			'Welcome! Complete the application materials to finish your membership application. Help us get to know you better.',
		deniedText:
			'We are sorry to inform you that your application has not been approved. It is possible that the information submitted was incomplete or incorrect. Please feel free to submit another application or contact us.',
		notValidText:
			'Uh oh. Your application materials are incomplete. Please complete all required fields.',
		notValidCertificate: 'Uh oh. Your personal information is incorrect. Please re-enter.',
		nameTooltip:
			'Important Note: Please provide the name that appears on the official ID used for your application. This may be required to verify your identity at move-in.',
		sexTooltip:
			'This information is only collected due to our dorm options, which sometimes have gender restrictions.',
		passportTooltip:
			"Important Note:If you don't have National Identification Card (Republic of China), please provide passport number for your application. This may be required to verify your identity at move-in.",
		skillsTooltip: '',
		presonalTooltip:
			'Use 300 words or less to describe your personal story. Please include your hopes and expectations related to your participation in 9floor.',
		privacyTooltip:
			'We encourage all residents to consider the advantage of making their information available to other residents. Sharing facilitates new friendships and connections.',
		nicknameTooltip: 'What would you like for other residents to call you?',
		avatarTooltip: 'Please upload a recognizable photo for verification.',
		introductionTooltip: 'Let your fellow residents get to know you better.',
		socialTooltip:
			'*Accounts must be verified, so please include at least one account for initial setup. After the verification processes, you can add more accounts.',
		addAvatar: 'Profile Picture',
		reviewUploadPhoto: 'Please upload a recognizable personal photo for review.',
		basicInformation: 'Basic Information',
		nameAlert:
			'Important Note: Please provide the name that appears on the official ID used for your application. This may be required to verify your identity at move-in.',
		selectFile: 'Select File',
		passportType: 'Passport Type',
		passportNumber: 'Passport Number',
		name: 'Name',
		fullName: 'Full Name',
		sex: 'Sex',
		sexAlert:
			'This information is only collected due to our dorm options, which sometimes have gender restrictions.',
		dateOfBirth: 'Date of Birth',
		selectBirthday: 'Birthday select',
		nationality: 'Nationality',
		selectNationality: 'Nationality select',
		passport: 'Passport',
		workingArrangements: 'Working Arrangements',
		jobTypes: 'Job types select',
		skills: 'Skills',
		skillTypes: 'Skills select',
		phoneNumber: 'Phone Number',
		personalIntroduction: 'Personal Introduction & Expections',
		words300:
			' Use 300 words or less to describe your personal story. Please include your hopes and expectations related to your participation in 9floor.',
		communityProfile: 'Community Profile',
		privacySetting: 'Privacy Setting',
		privacyDetail:
			'We encourage all residents to consider the advantage of making their information available to other residents. Sharing facilitates new friendships and connections.',
		nameForDisplay: 'Name (for display)',
		nickname: 'What would you like for other residents to call you?',
		company: 'Company',
		occupation: 'Occupation',
		selectOccupation: 'Occupation select',
		shortIntroduction: 'Short Introduction',
		words150: '150 words or less.',
		personalInterests: 'Personal Interests',
		interests: 'Interests select',
		website: 'Link Your Social Media and Website',
		music: 'Your Music',
		spotify: 'Search for your page',
		accountLink: 'Community Account Link',
		alertAccountLink:
			'Accounts must be verified, so please include at least one account for initial setup. After the verification processes, you can add more accounts.',
		instagram: 'Your Instagram',
		instagramLink: 'Link to Instagram',
		save: 'Save',
		submit: 'Submit',
		FEMALE: 'Female',
		MALE: 'Male',
		OTHER: '',
	},
	bookingBar: {
		available: 'Available',
		notAvailable: 'Rented',
		canBooking: '可即刻入住',
		waitRelease: 'Coming Soon',
		releaseTime: '{{MM}}/{{DD}}/{{YYYY}}',
		month: 'month',
		view: 'Schedule a Property Viewing',
		book: 'Book Your Room',
		noBook: 'Rented',
		reserved: 'Reserved',
		continue: 'Renew Your Lease',
		checkout: 'Schedule a Checkout Appointment',
		reservedMessage:
			'Tooltip: You have already reserved a {{eventType}} for this room. The appointment time is {{time}}',
		verifying:
			'Property viewings are only available after all {{link}} has been received and processed.',
		verifyingData: 'application information',
		verifyingPending:
			' Information Under Review: Application review requires two to three business days (weekends and national holidays are excluded). If your application result is overdue, please contact us.',
		verifyingDenied:
			'Hello! Due to insufficient information, we are currently unable to process your reservation. We recommend you complete the membership application again and provide more information about yourself. We want to get to know you better.',
		excessUserReserve: 'You have exceeded your allotted number of property viewings for this month',
		excessRoomReserve:
			'There are too many active reservations to view this listing. We recommend you choose another listing to view or add this listing to your favorites.',
		reject:
			'Due to an apparent conflict between your behavior and the values of the 9floor community, effective immediately we will suspend your use of all member-related services.',
		notCertificated:
			'Reserving rooms is reserved for certified members. For more details, please refer to our {{link}}.',
		viewIntro:
			'Before scheduling a viewing, please review the following rules and guidelines:\n\n1. Changes and Cancellations:\na) If you need to change or cancel your appointment, please use the member page to submit your request at least 24 hours in advance.\nb) If you need to cancel at the last minute or will be late for your appointment, please call the staff person scheduled to meet you as soon as possible.\nc) If you do not show up for your appointment, you will be unable to schedule a viewing or reserve a room for the following two months.\n\n2. If the apartment you wish to view is reserved by another member prior to your appointment, you will be contacted of the change via email. If this change of status occurs within 24 hours of your appointment, we will notify you by phone.\n\n3. Every member is allowed three property viewings per month.\n\nPlease accept our invitation to explore 9floor and find your new home.',
		bookIntro: `Living in our community will likely be slightly different than your previous rental experiences:

1. 9floor use NewebPay as the payment platform. NewebPay is compatible with VISA, Mastercard, and JCB credit and debit cards.
2. After receiving the order, 9floor will perform a final review of the invoice within 24 hours. If the personal information submitted does not match your membership information, 9floor reserves the right to cancel the order.
3. After the order confirmation has been completed, we are unable to refund the administrative fee if you need to modify or cancel the reservation.

Reminders:
1. Reserving a room is a limited service provided to members only. Your identity will be authenticated during the process. Do not use another person's account to make a reservation.
2. If you are completing an order where there will be a second resident, please make sure the listing allows this type of arrangement. Additionally, please verify the accuracy of your order.

If you violate any of the guidelines above, your membership may be directly canceled. Please refer to our `,
		term: 'Terms of Residence',
		bookIntroEnd:
			' for details.\nYou have three remaining steps before your reservation is complete',
		checkoutIntro:
			'For checkout, please leave your personal space in the same condition/appearance as check-in. Be sure to remove all personal belongings and trash. The checkout process will be conducted in accordance with the ',
		checkoutTerm: 'terms of stay',
		checkoutIntroEnd:
			'. And last but not least, don’t forget to come back and visit everyone after moving out!',
		serviceGuide: 'service guide',
		start: 'Start Reservation',
		next: 'Next',
		renew: 'Renew Your Lease',
		renewIntro: `Thank you for your continued support and participation.

Here are some guidelines for lease renewal:

1. The latest renewal date for your lease is {{renewDate}}
2. Renewal will not incur administrative fees, final cleaning fees, or additional deposit. If the lease was originally for more than six months, your first renewal will be subject to the long-term rental price regardless of the length of the new lease period.
3. If you would like to change your card payment preferences, you can modify your card settings after the order is completed on the order details page.`,
		appointment: 'Schedule a Move-in Appointment',
		appointmentIntro:
			'We are looking forward to your move-in day. Please set aside about one hour for the check-in process. One of our staff members will briefly meet with you to answer questions about the space, tell you more about the roommates, and go over a few details that we hope will help equip you to get connected quickly.',
	},
	booking: {
		notValidText:
			'Uh oh. Your application materials are incomplete. Please complete all required fields.',
		notValidCertificate: 'Uh oh. Your personal information is incorrect. Please re-enter.',
		notAcceptText: 'Uh oh. Please check the terms of stay.',
		notAcceptInsuranceText: 'Uh oh. Please check the insurance policy.',
		notValidFormat:
			'Uh oh. Your application materials is wrong. Please confirm all required fields.',
		empty: 'There is no record for this reservation.',
		notValidCreditNumber: 'The credit card information is incorrect.',
		notValidCreditDate: 'The expiration date is incorrect.',
		notValidCreditCVC: 'The security code is incorrect.',
		expiredCreditCard: 'Credit card authorization failed.',
	},
	bookingOrder: {
		invoiceInformation: 'Invoice Information',
		bookingTimezone: 'GMT+8 time',
		orderStartDate: 'Lease Start Date',
		leaseEnd: 'Lease ends in (month)',
		leaseEndPlaceholder: 'Lease ends in (month)',
		longTermRentalPrice: 'Long-term Rental Price: NTD {{rent}}/month',
		middleTermRentalPrice: 'Short-term Rental Price (3-5 months): NTD {{rent}}/month',
		shortTermRentalPrice: 'Short-term Rental Price (1-2 months): NTD {{rent}}/month',
		optionalItems: 'Optional Items',
		itemizedInvoice: 'Itemized Invoice',
		orderDate: 'Order Information:',
		roomName: 'Listing:',
		address: 'Apartment Address:',
		orderStartFrom: 'Order Start Date:',
		orderStartTo: 'Order Expiration Date:',
		next: 'Next',
	},
	bookingRent: {
		initialPayment: 'Initial Payment',
		monthlyPayment: 'Standard Monthly Payment',
		totalMonth: '{{count}} Month',
		totalMonth_plural: '{{count}} Months',
		total: 'total',
		deposit: 'Deposit',
		monthlyPrice: '{{price}} NTD/month',
		depositDescription: 'The lease deposit is equivalent to two-months rent.',
		administrativeFee: 'Administrative Fee',
		paymentDetail: 'Detail',
		administrativeFeeDescription:
			'When the first lease for each room is completed by the member resident, an administrative fee of NT$1,500 will be charged for lease processing. If the member resident renews the lease of the same room without any interruption between the two lease periods, the member resident will not be required to pay the administrative fee at the time of renewal. Any change made to the room reservation during the lease term shall be processed with an administrative fee of NT$1,500.',
		cleaningFee: 'Cleaning Fee',
		cleaningFeeDescription: `1.To ensure a good move-in experience and reduce checkout worries every room is professionally cleaned during a resident change. During checkout, you just need to remove all personal items and trash. We will take care of the rest.
2.When the first lease for each room is completed by the member resident, a checkout cleaning fee of NT$1,500 shall be charged. If the member resident renews the lease of the same room without any interruption between the two lease periods, the member resident will not be required to pay the checkout cleaning fee at the time of renewal.`,
		petCleaningFee: 'Checkout Cleaning Fee for Pets',
		petCleaningFeeDescription:
			'A pet checkout cleaning fee of NT$1,000 will be charged if a member resident keeps pets. The payment amount will be collected when the first lease for each room is completed by the member resident. If the member resident renews the lease of the same room without any interruption between the two lease periods, the member resident will not be required to pay the pet checkout cleaning fee at the time of renewal.',
		monthlyRent: 'Monthly Rent',
		monthlyRentDescription: 'The monthly rent is deducted on a fixed date every month.',
		serviceFee: 'Service Fee',
		serviceFeeDescription:
			'The service fee is the sum of both cleaning fees and the garbage disposal service fee for the space shared by member residents.',
		energyPrice: 'Utility Fee',
		energyPriceDescription:
			'The utility fee is the cost of utility services for the living space shared by the member residents. This includes water, electricity, natural gas, and internet fees.',
		petDescription: `1.Member residents may keep pets in spaces designated as appropriate by 9floor. Each member resident is limited to keeping only one pet in the premises of 9floor. This single pet may be a dog or cat (other pet types must be approved by 9floor).
2.The member resident checking-in with a pet shall pay an additional NT$1,500 per month. Guide dogs are not subject to such requirement or the additional charge stated in the preceding sentence.`,
		extraPersionDescription: `1.The member resident is prohibited from checking-in with an unsanctioned roommate. If the member resident has a guest for more than 10 days within one month, 9floor may choose to terminate the lease contract at any time, or alternatively may require the member resident to pay an additional NT$2,000 per month for the second resident.
2.The second resident is also required to abide by the terms of service agreement.`,
	},
	roomFilter: {
		select: 'Select ',
		city: 'City',
		neighborhood: 'District',
		MRT: 'MRT Station',
		MRTLine: 'MRT Line',
		surroundingMRT: 'Include surrounding MRT stations',
		station: '{{station}} Station',
		line: '{{line}} Line',
		type: 'Room Type',
		anticipatedMovein: 'Expected Move-in date',
		chooseMonth: 'Choose a Month',
		monthlyRent: 'Monthly Rent',
		limit: 'Minimum/ Maximum',
		particularApartment: 'Particular Apartment',
		chooseApartment: 'Apartment',
		advancedSearch: 'Advanced Search',
		size: 'Room Size',
		twoResidents: 'Two Residents',
		all: 'All',
		allowed: 'Allowed',
		notAllow: 'Not Allowed',
		pets: 'Keeping Pets',
		special: 'Special Features',
		showUnavailable: 'Include Rooms not Currently Available',
		clear: 'clear',
	},
	roomType: {
		MEN_LIVING: 'Male Dormitory Room',
		WOMEN_LIVING: 'Female Dormitory Room',
		CO_LIVING: 'Mixed Dormitory Room',
		ROOM: 'Private Room (shared bathroom)',
		STUDIO: 'Suite',
	},
	roomStatus: {
		RENTED: 'Rented',
		AVAILABLE: 'Coming Soon',
		FULL: 'Available',
	},
	room: {
		additional: 'Initial Payment',
		monthAdditional: 'Monthly Payment',
		deposit: 'Deposit',
		monthlyRent: 'Monthly Rent',
		energyPrice: 'Utility Fees',
		energyPriceDescription:
			'The utility fee is the cost of the living space shared by the member residents, including: water, electricity, natural gas, and internet fee.',
		serviceFee: 'Service Fee',
		serviceFeeDescription:
			'The service fee is the cleaning fee and garbage disposal service fee for the space shared by the member residents.',
		shortRent: 'Short-term Rent',
		shortTerm: 'Short-term',
		month: 'month',
		info: 'Room Info',
		apartmentInfo: 'Apartment Info',
		type: 'Room Type',
		size: 'Size (Area)',
		ping: 'ping',
		amenities: 'Amenities',
		apartmentAmenities: 'Apartment Amenities',
		neighborAmenities: 'Neighborhood Amenities',
		transportation: 'Transportation Info',
		recommended: 'Recommended Listings',
		recommendedApartment: '附近公寓',
		balcony: 'Balcony',
		kitchen: 'Kitchen',
		sharedBathrooms: 'Shared Bathroom',
		bedrooms: 'Bedrooms',
		totalFloors: 'Total Number of Floors',
		elevator: 'Elevator',
		cleaningService: 'Cleaning Service',
		garbageDisposal: 'Garbage Disposal',
		more: 'More',
		yes: 'Y',
		no: 'N',
		roomSize: ' m²',
		floor: ' floor',
		room: '',
		hasPet: 'Pets Allowed',
		roommate: 'Roommate',
	},
	rooms: {
		UpToDate: 'Update Time',
		HighestPrice: 'Highest Price First',
		LowestPrice: 'Lowest Price First',
		location: 'location',
		price: 'price',
		advancedSearch: 'Advanced Search',
		results: 'results',
		SortBy: 'Results sorted by',
		More: 'More',
	},
	roomComponent: {
		photos: 'More photos',
	},
	userTabs: {
		overview: 'Overview',
		settings: 'Settings',
		favorites: 'Wishlist',
		viewingHistory: 'Property Viewing Record',
		reservationHistory: 'Reservation History',
		request: 'Contact Us',
		onlineCommunity: 'Community',
	},
	userOverview: {
		welcom:
			'Welcome! Complete the application materials to finish your membership application. Help us get to know you better.',
		account: 'My Account',
		editProfile: 'Edit Profile',
		currentOrder: 'Current Reservation',
		checkinTime: 'Comfirm Move-in Time',
		details: 'View Details',
		recent: 'Recent Appointments',
		incomplete:
			'Uh oh.Your application is still incomplete. Go to the setup page to complete the information and re-submit the application.',
		underPreview: 'Your application information is under review.',
		reject:
			'We are sorry to inform you that your application has not been approved. It is possible that the information submitted was incomplete or incorrect. Please feel free to submit another application or contact us.',
		needCheckin:
			'Your move-in day is coming soon. Please remember to reserve your move-in appointment before {{startDate}}.',
		needCheckout:
			'Time flies! Your official checkout date is soon. Please remember to book your checkout appointment before {{endDate}}.',
		reserveMovein: 'Reserve Your Move-in Time',
		reserveCheckout: 'Reserve Your Checkout Time',
		member: 'Member',
	},
	bookingRecordCard: {
		address: 'Address',
		date: 'Order Date',
		moveinTime: 'Move-in Time',
		moveinAppointment: 'Schedule Move-in Appointment',
		checkoutAppointment: 'Schedule Check-out Appointment',
		renew: 'Renew Order',
		changeOrder: 'Change Your Order',
		download: 'Invoice Download ',
		changePayment: 'Update Payment Method',
		review: 'Review',
		cancel: 'Cancel',
	},
	bookingPayment: {
		DONE: 'Paid',
		NEXT: 'Next Payment',
		WAIT: 'Outstanding Payable',
		paymentHistory: 'Payment History',
		initialPayment: 'Initial Payment',
		total: 'Total:',
	},
	certificateType: {
		IDENTITY: 'Identity',
		PASSPORT: 'Passport',
		userAddress: 'Address',
		userAddressTooltip: 'Home address',
		certificateData: 'Official Document',
		extraCertificateData: 'Additional Residents',
		certificateDescription:
			'Please provide a copy of a current official document. The name listed must match the information previously provided.',
		certificateField: 'ID or Passport number.',
		emergencyName: 'Emergency Contact Person',
		emergencyTelephone: 'Phone Number of Emergency Contact Person',
		emergencyRelationship: 'Relationship',
		emergencyAddress: 'Address of Emergency Contact Person',
		selectFile: 'Select File',
		passportType: 'Document Type',
		passportNumber: 'ID Number',
		passportNumberTooltip: 'ID or Passport number.',
		basicInformation: 'Basic Information',
		communityProfile: 'Community Profile',
		name: 'Name',
		fullName: 'Full Name',
		sex: 'Sex',
		dateOfBirth: 'Date of Birth',
		nationality: 'Nationality',
		workingArrangements: 'Working Arrangements',
		skills: 'Skills',
		phoneNumber: 'Phone Number',
		personalIntroduction: 'Personal Introduction & ',
		expections: 'Expections',
		back: 'Go Back',
		next: 'Next',
		term: 'Terms of Residence',
		agreeTerm: 'I have read and understood the terms of residence',
		insurance: 'Insurance Policy',
		insuranceContent:
			'I understood and agree that 9floor will insure for accidents resulting from equipment failure within our facilities and fire/earthquake damaged for all roommates thus we will use the information provided above, including passport number, date of birth, home address and contact number. Note: There is not extra charge for the insurance.',
		agreeInsurance: 'I have read and understood the insurance policy',
	},
	modalLoginSignup: {
		forgetPasswordSendSuccess: 'An email has been sent to {{email}}. Please check your inbox.',
		verifySuccess:
			'Email verification successful! Please fullfill your personal information to complete the application.',
		welcomeBack: 'Welcome Home, 9floor Member.',
		SignupLoginFail: 'Uh oh. Your account information is incorrect. Please re-enter.',
		verifyEmailFail: 'The Email is not correct.',
		verifyPasswordFail:
			'Passwords must be at least 8 characters in length, including both characters and numbers.',
		verifyCheckPasswordFail: 'The passwords do not match.',
		verifyAgree: 'To complete the registration, you must agree to the Terms of Service.',
		verifyFail:
			'You have not yet verified your email address. Click below to resend the verification email.',
		vipTokenFailed:
			'The verification code is incorrect. Please signup directly or contact us. (Phone Number:+886 908959613)',
		agree: 'Agree to the',
		termsofService: 'Terms of Service',
		register: 'Register a New Account',
		already: 'Already registered?',
		loginNow: 'Login Now',
		successful: 'Registration Successful',
		verification_email:
			'To ensure uninterrupted service, please respond to your verification email.',
		back: 'Back to Home',
		resend: 'Resend Verification',
		rememberMe: 'Remember me',
		login: 'Login',
		forgot: 'Forgot your password?',
		reset: 'Reset Here ',
		not_a_member: 'Not a member yet?',
		application: 'Submit an Application',
		resetPw: 'Forgot your password? No worries. Reset it now',
		send: 'Send',
		newPassword: 'Set Your New Password',
		placeholder1: 'New Password',
		placeholder2: 'New Password Confirmation',
		becomeResident: 'Become a 9floor resident. Explore the city and share life together.',
		young: '年輕漂泊，',
		year: '最美好的那幾年。',
	},
	about: {
		bannerTitle: 'About',
		title1: 'Urban community for the future',
		title1Split1: 'Urban community',
		title1Split2: 'for the future',
		describe1:
			'In 2015 we started 9floor Coliving by renovating ten different urban apartments. In addition to private rooms, we created semi-public common spaces filled with the warmth of home. Our comfortable but minimal interiors attracted our first residents: students, office workers, freelancers, and internationals. Through our unique community-oriented business model, we are able to provide high-value housing to our residents. Our prompt and professional management also greatly benefits property owners. We work to activate urban spaces to their fullest potential for the benefit of both our residents and the surrounding community.',
		title2Split1: 'Not just space- A hub',
		title2Split2: 'for connecting',
		title2Split3: 'Not just space-',
		title2Split4: 'A hub for connecting',
		describe2:
			'Through space design, management services, and our membership system, 9floor provides superior living experiences tailored for today’s urban environment. Coworking, social events, communal meals, and events organized in conjunction with local cultural organizations occur regularly. Through the sharing spirit of coliving new connections are formed.',
		title3Split1: 'Humanizing the alienating cityscape-',
		title3Split2: 'Creating a new lifestyle',
		describe3:
			'In addition to our housing options for young people, 9floor has sought out opportunities to create new models meeting the particular needs of other age groups. Examples include intergenerational housing projects and new options in development for individuals already well-established in their adult lives. These projects have significant challenges, but we are motivated by our commitment to create a friendlier, more livable city.',
		qouteblock:
			'Become a part of our community. Try out the best lifestyle for today’s urban environment.',
		moreButton: 'Learn more',
	},
	bookingFinish: {
		congratulations: 'Congratulations!',
		content:
			'Your move-in appointment request has been received. We will review your request and confirm with you as soon as possible. Thank you again for scheduling an appointment. We look forward to seeing you at 9floor!',
		checkDetails: 'Check Reservation Details',
		returnToRoom: 'Return to Property Description',
	},
	page404: {
		headerText: 'The requested page does not exist.',
		paragraph: 'Error code: 404',
		buttonText: '9floor Home',
	},
	contact: {
		contact: 'Contact',
		support: 'Support',
		message: 'Leave a note to help us improve our service. ',
		request: ' Fill out a residential service request. ',
		inquiries: 'For all other inquiries please contact us at {{link}}',
		contactUs: 'Contact us',
		respond: 'Issue Report',
		property: 'Property Partner',
		propertyDescription:
			' If you are seeking property management services, please provide {{link}} and any special considerations. We will contact you as soon as possible',
		work: 'Work Partner',
		workDescription: 'Join our management team. Please see {{link}}.',
		investment: 'Investment Partner',
		investmentDescription:
			'If you are interested in providing a helping hand as we reshape the property rental industry, please contact us at {{link}}',
		media: 'Media',
		mediaDescription: 'For more information, please refer to our {{link}} page.',
		cooperation: 'Cooperation',
		cooperationDescription: 'Please provide {{link}}. We will contact you as soon as possible.',
		consulting: 'Consulting Services',
		consultingDescription:
			'For space planning services, please provide {{link}}. We will contact you as soon as possible.',
		space: 'basic information about the property',
		teamPage: 'Team',
		mediaPage: 'Media',
		proposal: 'basic information related to your proposal',
		become: 'Become Our Partner',
	},
	service: {
		serviceGuide: 'Service Guide',
		member: '1. 9floor Membership',
		suTitle1: 'Why become a resident member?',
		description1:
			'We continually work to improve our coliving and share spaces. However, we also understand that coliving lifestyles are not suitable for all. We strive to maintain a community that values intellectual freedom and diversity. Consequently, our process for resident selection may be different than what you expect. Once you have gone through the selection process, you become a community member. At different stages, you gain access to different services. These include community activities, the use of community space, the ability to reserve a room, etc.<br />As we continue to develop, we are constantly broadening our digital services. We are committed to the realization of a truly integrated online and offline shared community.',
		blockquoteTitle1: 'Our Ideal Residents',
		blockquoteList1: '1.Embrace the principles of {{link}} and community culture',
		blockquoteList2: "2.Willingly respect our diverse community's multifaceted nature",
		blockquoteList3: '3.Happily share, and work together within the community to grow',
		blockquoteList4: '4.Accept challenges and solve problems',
		blockquoteList5: '5.Are approachable, but committed to living intentionally',
		formTitle: 'Levels and Permissions',
		rowTitle1: 'Membership Level',
		rowTitle2: 'Method for Leveling Up',
		rowTitle3: 'Privileges/Service Items',
		rowTitle4: 'Explanation',
		columnTitle1: 'L1-Basic Member',
		column1Row1: 'An invitation letter will be sent out after the online application is reviewed.',
		column1Row21: '1.Room Viewings: 3 times per 30 days',
		column1Row22: '2.Online Community Newsletter',
		column1Row23: '3.Community Activities',
		column1Row3:
			'We invite all who value diversity to apply for our basic membership. Services include the ability to schedule property viewings, and a newsletter to keep you up to date on our latest activities. Become a key player in our community. ',
		columnTitle2: 'L2-Certified Member',
		column2Row1:
			'After the member has participated through property viewing, an online interview, and/or community activities an invitation to become a certified member will be generated.',
		column2Row21: '1.Free Room Viewings: 3 times per 30 days',
		column2Row22: '2.Online Community Newsletter',
		column2Row23: '3.Community Activities',
		column2Row24: '<b>4.The ability to immediately reserve a room</b>',
		column2Row3:
			'In order to maintain a diverse community that values respectful, we have created a process to help ensure that your personal philosophy and behavior are accommodating toward other members. We will send invitation letters to suitable candidates based on their interview and any other relevant communication. Once you are upgraded to certified member, you can book your desired room at any time!',
		columnTitle3: 'L3- Resident Member',
		column3Row1: 'Moving into a 9floor room.',
		column3Row21: '1.Free Room Viewings: 3 times per 30 days',
		column3Row22: '2.Online Community Newsletter',
		column3Row23: '3.Community Activities',
		column3Row24: '4.The ability to immediately reserve a room',
		column3Row25: '<b>5.Exclusive discounts at preferred partner vendors</b>',
		column3Row26: '<b>6.Full access to online community features</b>',
		column3Row3:
			'After becoming a resident, you can enjoy exclusive benefits such as exclusive discounts, dedicated customer service, and online community features. As a resident, your community is not only within your individual apartment but instead spread throughout our entire shared community.',
		reservationExpantation: '2. Online Property Viewing Reservation Process',
		description21:
			'Property viewings, inquiries, interviews, move-in, and check-out are all facilitated through our online reservation system.',
		description22:
			'Reserving a property viewing is open to <b>all members (basic and above)</b>. Members have the opportunity to reserve three viewings per month. The reservation process is described below:',
		description23: 'Step 1: Find an apartment you like, and click to select.',
		description24: 'Step 2: Select your preferred time slot, and submit your reservation request.',
		description25: 'Step 3: You should receive details confirming your appointment.',
		blockquoteTitle2: 'Change/Cancellation Policy:',
		blockquoteList21:
			'1.Changes/cancellations must be submitted via the online member page at least 24 hours in advance of the scheduled appointment.',
		blockquoteList22:
			'2.If you are suddenly unable to attend or will be late to the appointment, please call the staff scheduled to meet with you.',
		blockquoteList23:
			'3.If you fail to inform us you will be late or completely miss an appointment, you will be unable to reserve property viewings or directly book apartments for the following two months.',
		blockquoteList24:
			'4.If another potential resident signs a lease for the property before you are able to view it, we will notify you of the change by email. If this change occurs within 24 hours of your scheduled viewing, we will notify you by phone.',
		bookingExpantation: '3. Online Room Reservation Process',
		description31: 'The online room reservation option is reserved for <b>certified members</b>',
		blockquoteTitle3: 'Complete your room reservation in six steps:',
		blockquoteList31: 'Step1: Click “Reserve” on the room page to start your reservation.',
		blockquoteList32: 'Step2: Carefully confirm the room information and review the terms of stay.',
		blockquoteList33: 'Step3: Complete verification of your payment method.',
		blockquoteList34:
			'Step4: After you complete the online reservation process, we will review your information within one working day to confirm that all information is complete.',
		blockquoteList35:
			'Step5: After the reservation is approved, you may schedule your move-in appointment.',
		blockquoteList36: 'Step6: A staff member will help you check-in.',
		description32:
			'Basic members who have scheduled {{link}}, completed their introductory interview, and participated in community activities are eligible to be considered for <b>certified member</b> status. We will upgrade members based on their participation, suitability, and interest. Please refer to the certified member description for more information.',
		description33:
			'Room reservation is only for members. If you use other people’s accounts to reserve a room, we reserve the right to cancel the reservation and membership. Please refer to our {{link}} for details.',
		payRefundExpantation: '4. Financial Withholding and Refund Policy',
		description41:
			'9floor use NewebPay as the payment platform. NewebPay is compatible with VISA, Mastercard, and JCB credit and debit cards.',
		blockquoteList41:
			'1.After setup is complete, your account will be automatically debited every month. If necessary, you can check your transaction history at any time via the member page.',
		blockquoteList42: '2.Monthly rent deduction will occur on your lease start date.',
		blockquoteList43:
			'3.Other than the initial deposit, we will not place any advance holds on your account.',
		blockquoteList44: '4.If necessary, you have the option to change your preferred account.',
		blockquoteList45:
			'5.If you use an international (non-Taiwanese) card, your transaction may be subject to exchange and service fees. Check with the account provider for details.',
		onlineCommunityRule: '5. Online Community Rules',
		description51:
			'The online community is our latest feature for resident members. Go to your member settings page to fill out interest tags, link your Instagram connection, share your favorite music, and further customize your settings. If you choose to set your privacy preferences to open you will have more opportunities to connect with other residents.',
		description52:
			'As a platform for community interaction, there are still some guidelines that everyone needs to follow. Multiple violations could possibly be considered grounds for eviction. Please refer to our {{link}} for details.',
		blockquoteTitle5: 'The following behavior is prohibited:',
		blockquoteList51: '1.Malicious targeting and bullying are strictly forbidden.',
		blockquoteList52: "2.Do not share other people's personal details or contact information.",
		blockquoteList53:
			'3.Gossip: Shared community does not make the discussion of other residents’ private lives permissible.',
		blockquoteList54:
			'4.Disrespectful comments: Maintain good relationships with residents, neighbors, and the community.',
		blockquoteList55:
			'5.Discrimination: It is forbidden to discriminate on the basis of religion, gender, sexuality, ethnicity, or financial means.',
		blockquoteList56: '6.Sexual harassment is strictly forbidden.',
		coliving: 'coliving',
		property_viewings: 'property viewings',
		certified_members: 'certified members',
		terms_of_stay: 'terms of stay',
	},
	printOrder: {
		reservation: 'The Contract Agreement was sent to the member resident on {{link}} . (a reasonable period of at least 3 days must be given to consumers for them to review the contract terms.)',
		printButton: 'print',
		invoiceInformation: 'Invoice Infomation',
		orderDate: 'Order Date',
		room: 'Room',
		apartmentAddress: 'Apartment Address',
		movieInDate: 'Movie-in Date',
		checkoutDate: 'Check-out Date',
		termsOfService: 'Terms of Service',
		description: 'This Agreement is entered into between the Tenant ( referred to as “{{link}}” hereinaftert) and the sublessor (referred to as “9floor” hereinaftert). In consideration of the mutual covenants regarding the leasing of the premises, the parties hereby agree as follows:',
		companyInformation: 'Information of 9floor',
		companyName: 'Name of Company',
		companyNameValue: '共宅一生股份有限公司',
		companyResponsible: 'Name of Representative',
		companyResponsibleValue: '潘信榮',
		companyNo: 'VAT Number',
		RegistrationCertificateNumber: 'Certificate Number',
		RegistrationCertificateNumberValue: '(107) 北市租登字第0003號',
		companyAddress: 'Location of Company',
		companyAddressValue:
			'2F., No.119, Sec. 2, Xinhai Rd., Da’an Dist., Taipei City 106, Taiwan (R.O.C.)',
		user: 'Customer Info.',
		userName: 'Name',
		userBirthday: 'Birthday',
		userType: 'Type of ID',
		userNumber: 'ID number',
		userTelephone: 'Telephone',
		userAddress: 'Address',
		emergencyContact: 'Emergency Contact',
		emergencyName: 'Name',
		emergencyTelephone: 'Telephone',
		emergencyAddress: 'Address',
		emergencyRelationship: 'Relationship',
		manager: 'Manager of Rental Management',
		name: 'Name',
		certificateNumber: 'Certificate Number',
		residentAddress: 'Location of Company',
		residentAddressValue: 'No.64, Sec.3, Heiping W. Rd., Wanhua Dist., Taipei City',
		phoneNumber: 'Contact Number',
		mailAddress: 'Email',
	},
	termsOfService: {
		serviceTerms: 'Service Clause',
		paragraph1: 'Welcome to 9floor Coliving',
		paragraph2:
			'9floor is a rental housing service registered under the Republic of China Residential Law.We provide services such as space management and planning to the residents of the Republic of China.The following use of “this website” refers to, but is not limited to websites with Japanese or Taiwanese domains, including new or modified websites.',
		paragraph3:
			'The following use of “this website” refers to, but is not limited to websites with Japanese or Taiwanese domains, including new or modified websites.',
		paragraph4:
			'The company team will provide services and information to customers in accordance with the following stipulations ("the Terms of Service“).',
		paragraph5:
			'If the customer uses 9floor, they will be deemed to have agreed to the Terms of Service. Please read these terms carefully. ',
		paragraph6:
			'In addition, if the customer will use the current or future services of 9floor, link to the website of the partner businesses or purchase goods, regardless of whether the website contains this information, the guidelines for utilization of the service or business shall be followed.',
		paragraph7:
			'If any usage guidelines or service descriptions are different from the contents of these Terms of Service, the policies herein take precedence.',
		title1: 'Regarding Privacy',
		paragraph8: 'The privacy policy applies to customers when they use the property.',
		paragraph9: 'Please carefully review the following policies.',
		title2: 'Electronic Communication',
		paragraph10:
			'If the customer uses 9floor or sends an e-mail to 9floor, this is considered to be electronic communication.',
		paragraph11:
			'The customer agrees in advance that all e-mail notification sent to the address registered by the customer or posted notices on the website or other means of communication through the website serves as a means of business notification or advertising that is a part of 9floor’s service. The customer shall agree that 9floor’s provision of electronic notices, information disclosures, or other communications to the Client shall serve as legal written notice.',
		title3: 'Copyright',
		paragraph12:
			'All content provided by 9floor (including but not limited to text, graphics, layouts, logos, button icons, images, videos, audio clips, and all other digital content) is protected by Republic of China, Japanese, and international copyright laws. All written content is protected by Republic of China, Japanese, and international copyright laws. It is forbidden to reproduce the information and media provided by 9floor without permission.',
		title4: 'User License and Linked Content',
		paragraph13:
			'As a condition of compliance with these terms of service 9floor grants users the personal (non-transferable) right for limited, non-exclusive, non-commercial use of our content. The license for use does not include rights for resale or any other use of content for commercial purposes. The collection and use of product forms, comments, prices, etc. as well as personal user account information is strictly forbidden. The use of data collection and extraction tools, data mining, bots, etc. is strictly forbidden.',
		paragraph14:
			'The rights not expressly granted by these terms of service or other terms of service are reserved by 9floor or its licensors, suppliers, publishers, rights holders, or other content rights holders. Copying, printing, selling, re-selling, linking or any other unsanctioned use of content for commercial purposes is strictly forbidden without express written permission. The company logo and all other creative/intellectual property (including but not limited to images, text, page layout, form, etc) shall not be used or replicated without express written permission. Improper use of 9floor and violation of these terms of services may be punishable by law. Additionally, 9floor reserves the right to refuse service or cancel service based on violations of these terms. This decision is made at 9floor’s discretion.',
		title5: 'Account Security',
		paragraph15:
			'When using this website, maintaining the confidentiality of the your account and password, and restricting connection to the computer you use to access your account is solely the responsibility of the user. The customer is responsible for any improper use of the account by a third party. In addition, if the customer leaks the account and password information to a third party or has information stolen, they should contact 9floor as soon as possible. 9floor may, at our sole discretion, stop or terminate the use of the account and password on this website without prior notice. Regardless of whether the issue is due to customer error, if the account and password are stolen or lost this may result in temporary suspension of use or termination of your account on the website. All expenses incurred by the temporary account suspension or account termination (including but not limited to investigation costs, countermeasures against recurrence, lawyer fees, customer complaints, etc.) are the responsibility of the customer and will not be repaid by 9floor.',
		paragraph16:
			' We reserve the right to refuse service, stop accounts, delete and edit content, and change or cancel activities solely based on our own discretion and without notice.',
		title6: 'Registration Information Changes',
		paragraph17:
			'If your preferred email or other contact information has changed, the information should be updated in a timely manner. 9floor is not responsible for the inability to obtain service resulting from failure to provide accurate contact information or other registration matters.',
		title7: 'Unaccompanied Minors',
		paragraph18:
			'If a customer is determined to be a minor according to the law of their home country or territory, they must register with parental consent (or the consent of another functioning legal representative). If it is determined that no consent has been obtained, 9floor reserves the right to immediately refuse to provide service and suspend the account.',
		title8: '評價、留言、通訊、其他內容物',
		paragraph19:
			'利用玖樓之客戶得進行留言、貼圖或其他內容物之發文、傳送提案、想法、意見、問題或其他資訊。但該等內容包括違反法令、猥褻、脅迫、毀損名譽、侵害隱私權、侵害智慧財產權、毀謗中傷第三人、令人感到不悅、或軟體病毒、政治主張、商業目的之勸誘、連鎖信、大量發信或所謂「垃圾信」，以及違反刑法第360條者，則不在此限。不得使用虛偽之EMAIL信箱、冒充他人或組織、其他內容物之出處進行招致誤解之行為。玖樓保有將該等內容刪除或編輯之權利（並非義務），但並非定期確認發文內容。',
		paragraph20:
			'客戶進行內容物之發文或傳送素材時，除非本網站明示其他決定，應視為客戶授予玖樓使用、重製、變更、改作、公開、翻譯該等內容物、作成、散布第二次著作物、得以所有媒體型態向全世界表示其為非獨占性、無償、永續性、無法取消、包括完整再授權之權利。客戶於玖樓與被轉授權人希望時，視為客戶就該等內容物對其授權使用客戶發文名稱之權利。此外，客戶不得對玖樓或玖樓再授權之第三人行使著作人格權。客戶應聲明、保證保有或管理自身發文內容物相關所有權利、該內容物係屬正確、所提供內容物之使用並未違反此政策、未傷害任何他人或組織、就起因於其提供之內容物之所有請求向玖樓提出補償。玖樓不保證確實記錄或保存發文之資訊或素材。縱使該等資訊或素材之全部或部分消失、變樣或外流，無論其原因為何，玖樓概不負責。玖樓保有監視、編輯或刪除任何行為或內容物之權利，但並無義務。玖樓對於客戶或第三人發文之任何內容物亦不負責，未生義務。',
		title9: '侵害智慧財產權之相關聲請',
		paragraph21:
			'玖樓尊重他人智慧財產。經判斷客戶之著作物於本網站上，遭以如構成侵害著作權或智慧財產之方法複印或使用時，請依玖樓適當指定之智慧財產權侵害相關聲請程序，提出聲請。',
		title10: '商品及服務說明',
		paragraph22:
			'玖樓將致力於盡可能保持正確性。但玖樓不保證商品説明或本網站其他內容正確、完整、具信賴性、為最新內容、或係為無誤。',
		paragraph23: '請留意本項規定僅適用於玖樓所介紹之商品。',
		title11: '得利用玖樓之軟體條件',
		paragraph24: '利用玖樓時，推薦以下瀏覽器之最新版本。',
		paragraph25: 'Google Chrome',
		paragraph26: 'FireFox',
		paragraph27: 'Safari',
		title12: '由第三人提供',
		paragraph28:
			'玖樓不對身為第三人之企業或個人、第三人之行為、商品、內容物負任何責任，亦不產生義務。建議請仔細閱讀各公司之隱私權相關文件與利用規約。',
		title13: '免責事項',
		paragraph29:
			'除非另有書面規定，客戶得透過玖樓及本網站利用之所有資訊、內容物、素材、商品（包含軟體）及其他服務，玖樓以「現狀之原有狀態」及「得提供之限度」提供之。玖樓除非另有書面規定，就玖樓之營運或本網站或玖樓所登載資訊、內容物、素材、商品無論其為明示或黙示，不為任何種類之聲明與保證。並視為客戶已明示同意以自身責任利用玖樓。特別就本網站保存之資料消失，或伺服機運轉停止所發生之客訴、爭議、損害賠償請求等情況之一切損害、責任，視為已明示同意免除玖樓責任。',
		paragraph30:
			'玖樓並未就客戶透過玖樓及本網站得以利用之所有資訊（以下簡稱「提供之資訊」。）相關商品或服務之購買、出售、持有或利用、或該等申請（以下統稱「購買等行為」。）為任何推薦。',
		paragraph31:
			'關於提供之資訊內容可能隨時變化，故請客戶勿全面依據提供之資訊，而係依自身判斷進行購買商品或服務等行為。無論其是否經由本網站，玖樓就客戶所為之商談或契約並非當事人，亦不對商議業務予以對應，且概不負責。',
		paragraph32:
			'玖樓不介入以利用本網站為契機發生之所有客戶間之協商、交易。就客戶間之交易所發生各種作業、連絡、法律義務之履行及問題處理等，應由客戶間負責為之。就起因於利用本網站為契機所為交易之損害，及起因於揭露提供之資訊一事本身之損害，玖樓概不負責。',
		paragraph33:
			'玖樓就得透過本網站連結或取得之產品或服務，於適用之法律所認可之範圍內，無論其為明示或默示，不為一切保證（包括但不限於未違反特定目的，及就該目的具市場性或合適性者。）。玖樓不保證資訊、內容物、材料、商品（包含軟體）、包含於玖樓其他服務或由其提供之服務、伺服器、由玖樓寄送之EMAIL，未感染病毒或其他有害因子。',
		paragraph34:
			'玖樓對於使用玖樓所生之任何種類之損害，包含但不限於直接、間接、附隨、懲罰性、必然性之損害亦不負責。',
		title14: '準據法',
		paragraph35:
			'利用玖樓時，視為已同意無論法律牴觸原則為何，以中華民國國內法規範利用此規約，以及客戶與玖樓或支援玖樓之企業間可能發生之，與玖樓有關之所有類型爭議。',
		title15: '爭議',
		paragraph36:
			'關於連結至本網站以及利用規約相關之爭議，除法律認可之管轄法院外，附加指定台北地方法院為合意管轄法院。但關於身為企業經營者之客戶，指定台北地方法院為專屬之合意管轄法院。',
		title16: '網站之營運方針、變更、可分性',
		paragraph37:
			'詳閱登載於本網站關於價格等事宜之本網站營運方針。該等方針亦就客戶利用玖樓一事予以規範。玖樓保留得隨時變更本網站、營運方針、利用規約之權利。該規約之一部分為不當或無效、或因任何理由而無法施行時，該規約視為可分，不影響此部分以外規約之有效性及拘束力。',
		title17: '關於本網站之營運母體',
		paragraph38:
			'本網站由玖樓團隊進行管理營運。就本規約中規定玖樓得持有或行使之一切權限及權利暨免責事項，以及支援玖樓之企業或其從業人員得行使或為主張。',
		title18: '詢問信箱',
		paragraph39: 'EMAIL: support@9floor.co',
		title19: '個人資料保護方針',
		paragraph40:
			'各位客戶您好:<br />關於此文件，請於提供玖樓個人資料前閱讀一遍。於您同意後，將提供個人資料所伴生之各種服務。',
		subTitle1: '1. 個人資料之收集、處理及利用目的',
		listDescription1:
			'・本服務就所取得之客戶個人資料，將以下揭目的（以下簡稱「利用目的」）利用之。',
		listTitle1_1: '(1)  本服務會員身份之利用',
		listItem1_1:
			'・作為註冊本服務會員利用服務時之登入時及登入後之身份認證、各種畫面中之會員資料自動顯示。',
		listTitle1_2: '(2)  本服務所提供交易之完成',
		listItem1_2:
			'客戶參加抽獎、線上報名等活動、回應客戶所詢問題、由本服務向客戶提出詢問、相關售後服務、其他完成交易所需業務。',
		listTitle1_3: '(3)  本服務之廣告宣傳或行銷等',
		listItem1_3_1: '・提供客戶各種電子報等資訊。',
		listItem1_3_2: '・以電子郵件、郵寄信件、電話等提供服務相關資料。',
		listItem1_3_3:
			'・對於客戶瀏覽之內容物或廣告依客戶之性別、年齡、居住地、興趣/嗜好等個人屬性或購物紀錄及本服務網站之瀏覽紀錄設定個人化資料。',
		listItem1_3_4: '・伴隨分析客戶於本服務之利用内容，開發新服務或改善現有服務。',
		listItem1_3_5: '・進行意見調查、活動、評價等與服務相關之客戶聯絡。',
		listTitle1_4: '(4)  回應客戶所詢問題',
		listItem1_4: '・回應客戶於本服務以電子郵件、郵寄信件等所為之詢問。',
		listTitle1_5: '(5)  其他伴隨本服務之利用',
		listItem1_5: '・伴隨上述(1)至(4)，就本服務之提供判斷有必要而利用之情況。',
		listTitle1_6: '(6)  提供予服務提供人',
		listItem1_6: '・依「3.個人資料等之提供/委託」提供個人資料予服務提供人。',
		listTitle1_7: '(7)  其他',
		listItem1_7:
			'・於個別服務亦可能以未規定於上揭內容之目的利用個人資料。於此情形時，將於個別服務網站中登載該內容。',
		subTitle2: '2. 個人資料之取得方法、利用期間與地區',
		listDescription2:
			'服務之提供方面，主要是取得如下之客戶相關資料。將取得之項目為非必要項目，而無法取得該項目時，可能無法提供本服務、回應客戶所詢問題等事宜，敬請見諒。',
		listDescription2_1:
			'再者，以下為例示，此外，依資料具體內容亦可能有未符合個人資料之情形，得依利用目的之差異或需求，增刪已收集之個人情報類別與項目，敬請見諒。',
		listTitle2_1: '(1)  客戶提供之資訊',
		listItem2_1:
			'・姓名、性別、出生年月日、居住地、使用語言、宗教、電子信箱、手機信箱、現在身處位置相關資訊及入住村民會員調查表之回答資訊等客戶所提供之一切資料。',
		listTitle2_2: '(2)  與利用服務有關而取得之資訊',
		listItem2_2:
			'・客戶申請玖樓提供之社群活動、或其他交易時之得以辨識客戶之資訊，與係屬附帶狀態之交易紀錄相關資訊。',
		listTitle2_3: '(3) 以連結為契機，機械上所取得之資訊',
		listItem2_3_1:
			'・客戶電腦連結網路時使用之IP位置、手機之機體辨識相關資訊（包含連結地點之資訊）。',
		listItem2_3_2:
			'・除以連結本網站為契機取得之所使用瀏覽器種類/版本、作業系統、平台等外，客戶瀏覽之網頁 (URL)、瀏覽日期時間、標示或查閱商品等相關資訊。',
		listItem2_3_3:
			'・除上述外，使用小型文字檔案(cookie)或網頁信號(web beacon)之技術取得之連結資料等，於每次客戶利用本服務自動收集/保管之資料。',
		listTitle2_4:
			'(4) 個人資料利用期間:自客戶最新登入日起算之一年間。但帳號遭刪除時，客戶的個人資料也將一併被刪除。',
		listTitle2_5: '(5) 個人資料利用地區:台灣、日本',
		subTitle3: '3. 個人資料等之提供/委託',
		listDescription3:
			'本服務依中華民國之個人情報保護法處理個人資料，除法令規定之情況外，未經客戶許可，未有將該資料揭露、提供予第三人之情形。但亦有於達成利用目的所需之範圍內，提供客戶個人資料、或委託處理個人資料之情形。於此情形下，於第三人之契約規定將進行與本文件同樣之資料管理，適當確認第三人身份及由第三人所為之管理體制。',
		listTitle3_1: '(1) 提供/委託之目的同於「1. 個人資料利用目的」。',
		listTitle3_2: '(2) 提供之個人檔案與「2.個人資料之取得方法」相同。',
		listTitle3_3: '(3) 提供、委託人之範圍為業務上所需服務之提供人。',
		listTitle3_4: '(4) 提供之手段、方法為本服務管理系統、CD-ROM等電子媒體、紙面等類比媒體等。',
		listTitle3_5:
			'(5) 要求停止向提供人、委託人提供資料時，請採取「5. 個人資料利用目的之通知、揭露、訂正/新增/刪除或利用之停止/消去/停止提供予第三人」之程序。',
		subTitle4: '4. 個人資料之保護',
		listDescription3_2:
			'就客戶所提供之個人資料為適當管理，為防止個人資料之洩漏、滅失、或毀損，乃從技術及管理面採取適當且合理之保護處置。此外，本服務約定依係屬營運公司之共宅一生股份有限公司之個人資料保護方針設置保護管理之負責人，於該負責人指示下，限定正當之服務進行範圍，嚴格進行收集/利用/提供/管理/保護。',
		subTitle5:
			'5. 個人資料利用目的之通知、揭露、訂正、新增或刪除、或個人資料之利用停止、消去或停止提供予第三人',
		listItem3_1:
			'・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_2:
			'・關於刪除或消去之程序，由客戶本身自「FAQ」頁面為之或由客戶透過「Contact Us」提出請求。Fun! Japan將以停止利用服務或停止向第三人提供個人資料對應之。',
		listItem3_3:
			'・玖樓有保管備份檔案，以備電腦故障或其他不可抗力或人為疏失導致之檔案消失之情形。該備份檔案性質上無法進行確認等程序。',
		listItem3_4:
			'・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_5:
			'・客戶利用本服務時，將視為已就「5. 個人資料利用目的之通知、揭露、訂正、新增或刪除或個人資料之利用停止、消去或停止提供予第三人」予以同意辦理。',
		subTitle6: '6. 未成年客戶之個人資料',
		listDescription3_3:
			'本服務就所提供之未成年人資訊，經謀求與大人同様之保護。但就依個人資料之當事人所在國或區域法令，經認定為未成年人者，按必要可能須得到家長同意。',
		subTitle7: '7. 個人資料相關詢問窗口',
		listDescription3_4: ' 關於個人資料之處理，如有不明瞭的地方，請參照求助網頁。',
		subTitle8: '8. 本網站之安全',
		listDescription3_5: '・本服務為確保客戶個人檔案之正確性、最新性，亦有可能請客戶予以協助。',
		listDescription3_6:
			'・本服務為確保安全，以防止個人輸入特定個人資料等重要資料時，該等資料遭竊取、受阻或竄改為目的，乃使用SSL（Secure Sockets Layer）技術。',
		paragraph42: '以上',
	},
	team: {
		team: 'Team',
		room: '房子是租來的，',
		life: '但生活不是',
		subject:
			'We are deeply inspired by the <a class="underline" href="https://www.ideo.com/post/the-ten-faces-of-innovation" target="_blank" rel="noopener noreferrer">10 faces of innovation</a> as identified by IDEO’s general manager, Tom Kelley. Individually, these archetypes are not the most powerful people, but each character has its own unique tools, viewpoint, and advantages. Through seeking out and combining these key types, we create a powerful organization capable of creating meaningful change in the city.',
		title1: '從實體社群出發，我們希望每個夥伴都是人類學家',
		career1: '1.人類學家',
		careerDescription1: '在共生日常裡進行田野調查',
		career2: '2.看護人',
		careerDescription2: '理解室友的生活需求，提供每個人適切合宜的居住選擇',
		career3: '3.說故事的人',
		careerDescription3: '透過生動故事和大眾溝通',
		career4: '4.實驗家',
		careerDescription4: '把生活問題、構想製成原型',
		title2: '多元創新，是我們骨子裡流的血',
		career5: '5.跨欄運動員',
		careerDescription5: '不斷克服障礙抵達終點',
		career6: '6.體驗建築師',
		careerDescription6: '優化室友的日常生活體驗',
		career7: '7.異花授粉者',
		careerDescription7: '探索其他產業和文化應用於共生之中',
		title3: '共享共創，這是一場弱連結的策展',
		career8: '8.導演',
		careerDescription8: '激發社群的內容與創造力',
		career9: '9.共同合作人',
		careerDescription9: '把各式各樣有趣的室友、外部團體結合',
		career10: '10.舞台設計師',
		summary:
			'Whether as a resident, active participant, or distant admirer, we hope you will join us on our journey as we build a friendlier, more livable city.',
		LinkedIn: 'Our LinkedIn',
		Medium: 'Our Medium',
		qouteblock:
			'If you are interested in joining our team, please follow our Medium account to stay up to date on current job postings.',
	},
	media: {
		bannerTitle: 'Media',
		sectionDescription:
			'To support the greater coliving movement, we are happy to share our experience and philosophy. Our brand book is also available for download For an extensive look into our community, please fill out an interview request form. A selection of past press features is available below:',
		listTitle1: 'Community Development In Taiwan',
		listTitle2:
			"Taipei's 9floor Coliving: Defending the value of intergenerational co-Living through a new experimental project",
		listTitle3:
			"Pursuing A Better Life Together: Communication is empathizing with each other's values's",
		listTitle4: 'My Old Roommate',
		listTitle5:
			"9floor Coliving: Transforming Taipei's old apartments, living in the city without alienation",
		listTitle6:
			'Creating A New Lifestyle Inside Old Apartments: Filling generational gaps in the cityscape',
		listTitle7:
			'"Urban Community For The Future" 9floor Coliving: Lively housing options for young renters',
		listTitle8: 'Living in a Community',
		listTitle9: 'Re-imagining The Concept Of Home: Promoting coliving apartments',
		listTitle10: 'The Rising Age Of Coliving: Moving the economy closer to the people',
		listTitle11: "Independent Living Doesn't Mean Living Alone",
		listTitle12:
			'Space Sharing In Cities With High Housing Costs: 9floor Coliving, A new choice for renters',
		listTitle13: 'Redefining Cohabitation: 9floor Coliving is creating a new concept of home',
		listTitle14: 'Individualism From Physical To Spiritual: An economic explosion',
		listTitle15: 'Must include CV to Rent?',
		listTitle16: 'The Madness Of A Sociology Teacher: Changing Taiwan Through One Course ',
		listTitle17:
			'Conditions And Opportunity For Intergenerational Coliving: Elderly Society And Vacant Apartments',
		listTitle18: 'Coliving, Greater Economic Efficiency',
		listTitle19: 'Coliving: A new trend breaking the traditional housing mold',
		listTitle20:
			'Share Space: Three Examples Not Just For Work- The Common, Sit Together, 9floor Coliving',
		listSubtitle1: 'SOTOKOTO(ソトコト) December 2017 Issue',
		listSubtitle2: 'Ming Pao Weekly',
		listSubtitle3: 'The News Lens- Becoming Aces',
		listSubtitle4: 'Public TV IN-NEWS',
		listSubtitle5: "c'est si bon",
		listSubtitle6: 'Polysh',
		listSubtitle7: 'Social Enterprise Insights',
		listSubtitle8: 'TED x TKU',
		listSubtitle9: 'NPOst',
		listSubtitle10: 'POINT',
		listSubtitle11: '30 Magazine',
		listSubtitle12: 'GREEN Magazine',
		listSubtitle13: 'LaVie',
		listSubtitle14: 'Business Today',
		listSubtitle15: 'Business Weekly',
		listSubtitle16: 'CommonWealth',
		listSubtitle17: 'Village Taipei',
		listSubtitle18: 'FTV',
		listSubtitle19: 'TVBS',
		listSubtitle20: 'BIOS Monthly',
		interview: 'Media Cooperation',
		download: 'Brand Book (Download)',
		require: 'Contact Us',
		record: 'Stories',
	},
	manager: {
		bannerTitle: 'Space Management',
		summaryTitle: '9floor Coliving',
		summary:
			'We are a comprehensive community management oriented coliving brand. Specific services offered include branding consultation, design planning, construction, leasing, and business management. We help property owners activate idle assets and improve surrounding communities.',
		sectionTitle1:
			'The Development of Coliving Spaces<br> is a Win-win for both Residents and Society',
		sectionDescription11:
			"From the perspective of redevelopment, coliving spaces occupy an area between business class hotels and long-term rentals. There is a balanced emphasis on both affordability and tangible services. The price is slightly higher than traditional rental property, but building and operating costs are significantly lower than traditional hotels. Additionally, profit is relatively stable because housing is a fixed need. Through our team's long-term consulting services, assets are activated and maintained.",
		sectionDescription12:
			'An added benefit of our professional management is a revitalization of the surrounding society. New threads are woven into local history. Property owners, investors, residents, and the surrounding city all benefit from an enlivening spirit of sharing and co-creation.',
		sectionTitle2: 'Why Work with 9floor?',
		sectionDescription21:
			'9floor is a pioneer of professional coliving spaces in Taiwan. From our grassroots beginning, we have consistently worked to create the best coliving options possible. In just three years we have received almost 3,000 resident applications and accumulated over 30,000 online followers. In addition to media accolades, we have also joined with the New Taipei City Government to create an intergenerational public housing project in Sanxia district and a social housing project in Yonghe district. In 2017 we became a <a class="underline"  class="underline" href="https://news.ltn.com.tw/news/local/paper/1138446" target="_blank" rel="noopener noreferrer">certified property manager for the Taipei City Government.</a>',
		sectionDescription22:
			'As an organization, we have a history of close interaction and collaboration with like-minded organizations and innovators within Asia. We were awarded Hong Kong’s <a class="underline" href="https://www.socialinnovationaward.asia/about-us/" target="_blank" rel="noopener noreferrer">Asia Social Innovation Award (2017)</a>, served as the Taiwanese representative in Seoul’s <a class="underline" href="https://www.facebook.com/Anyse.Asia/" target="_blank" rel="noopener noreferrer">ANYSE (2016)</a>, and are mentored by Social Enterprise Insights iLab and the Taipei City Government Department of Economic Development. With our international vision, local experience, and unique management abilities, 9floor is the superior choice for creating higher value from your real estate assets.',
		sectionTitle3: 'Service Options',
		row1Title: 'A. Comprehensive Planning',
		row1Subtitle1: '1.Coliving Space',
		row1Subtitle2: '2.Space Brand Planning',
		row1Subtitle3: '3.Community/Social Experience',
		row1Description1:
			'Market Analysis, Financial and Benefit Analysis, Space Utilization Planning, Mixed-use Development Planning',
		row1Description2:
			'Consulting Services, Service Design, Operations Standards Development, Staff Training, Integrated Digital Marketing',
		row1Description3:
			'Community Activity Planning, Online Community Event Planning, Neighborhood Co-creation Planning',
		row2Title: 'B. Design Supervision',
		row2Subtitle1: '1.Renovation',
		row2Sbtitle2: '2.Smart Home Integration',
		row2Description1: 'Space Restoration and Modification, Interior Design, Landscape Design',
		row2Description2: 'Smart Locks, Interior Renovation Projects',
		row3Title: 'C. Operations Management',
		row3Subtitle1: '1.Resident Management',
		row3Subtitle2: '2.Product Management',
		row3Description1:
			'Resident Recruitment and Selection, Online Contract Management, Client Relations',
		row3Description2: 'Cleaning, Repairs, Maintenance, Property Insurance',
		section3Title:
			'We are actively seeking the following cooperative partnerships to create more coliving spaces:',
		section3TitleWithHTML:
			'We are actively seeking the following cooperative partnerships<br> to create more coliving spaces:',
		section3Sub1: 'Vacant Properties',
		section3Sub2: 'Special Projects',
		section3Sub3: 'Cross-Industry Alliances',
		section3Description1:
			'We are constantly looking for new spaces to update. This includes any property suitable for blending private residence with shared common space. Convenient access to public transportation is a necessity. Unique local history is also a plus!',
		section3Description2:
			'We hope that 9floor’s coliving and share spaces throughout the city can be incubation spaces for the creation of new culture. We welcome all proposals and are actively seeking possibilities for collaborations related to social design, community building, and innovating for future societ',
		section3Description3:
			'Stemming from our ongoing exploration of lifestyle and space, we are actively seeking strategic partners in the following areas: smart home technologies, green appliances, healthy food options, lifestyle brands, etc. Help us create a sustainable city.',
		blockquoteWithHTML:
			'Want to know more? Please provide us with basic information regarding your proposal. We will contact you as soon as possible.',
		contactUs: 'contact us',
		sloganLeft: '享受社交生活。',
		sloganRight: '在宜居的環境裡，',
		sloganTitle1: 'What is Coliving?',
		sloganTitle2: 'What is Coliving?',
		sloganContent:
			'As inherently relational beings, we require much more than just a place to sleep. Social connections, cultural activities, and simple relaxation are just a few of our many critical needs. Coliving is one solution to make sure that these needs are met. Unlike renting a single room, living in a coliving space grants access to shared space (kitchens, living areas, event spaces, etc.) where community naturally grows.',
	},
	coliving: {
		coliving: 'Coliving Life',
		summaryTitle: '9floor Coliving',
		summaryDescription:
			'9floor is a community management driven coliving brand. Through space design and diverse community, we provide superior living experiences tailored to fit your contemporary urban lifestyle.',
		sloganTitle: 'What is Coliving?',
		slogan: '房子是租來的，但生活不是',
		sloganContent:
			'As inherently relational beings, we require much more than just a place to sleep. Social connections, cultural activities, and simple relaxation are just a few of our many critical needs. Coliving is one solution to make sure that these needs are met. Unlike renting a single room, living in a coliving space grants access to shared space (kitchens, living areas, event spaces, etc.) where community naturally grows.',
		title1: 'A. Coliving Space',
		description1:
			'The warm atmosphere of home with the internet access and communal workspace of a coffee shop. We curate thoughtful environments that offer a much-needed respite from the bustle of the city. Take your time sipping your morning coffee. Share a bottle of wine with your new neighbor as you unwind from the workday. Bring comfort and beauty back into your everyday routine.',
		imageDescription1:
			'From heirloom recipes to late night ramen noodles, communal kitchens are an inviting space for sharing food and conversation.',
		imageDescription2: 'Make plans, prepare for exams, or enjoy your afternoon coffee break.',
		imageDescription3:
			'Come home to your personal hideaway, and forget the worries of the workday.',
		title2: 'B. Convenient Leasing',
		description2:
			'With automated bill pay, you no longer need to remember to pay your rent. A single online bill takes care of all expenses. If you are an intern, exchange student, or working on a short-term project, our one-month minimum frees you from the confines of a long lease.',
		imageDescription4:
			'Our billing includes all utilities, cleaning fees, and administrative costs. One payment takes care of it all.',
		imageDescription5:
			'Automatic payment options. You no longer need to set a reminder for your rent.',
		imageDescription6:
			'Remote working, internships, short-term projects- with a one month minimum for leasing your options are flexible.',
		title3: 'C. Daily Support',
		description3:
			'Weekly common area cleanings and garbage disposal save your precious time. Online maintenance requests minimize inconvenience and ensure timely resolution.',
		imageDescription7:
			'Online maintenance requests with response times within 24 hours. Qualified service technicians quickly resolve facilities issues.',
		imageDescription8:
			'Regular cleaning service for common areas and garbage disposal. *Excessive garbage or large items will be the responsibility of the resident.',
		imageDescription9:
			'We are insured for accidents resulting from equipment failure within our facilities.',
		title4: 'D. Communal Life',
		description4:
			'Our personal experiences may be limited, but the diverse {{link}} is a jumping off point for exploring new ideas and expanding your perspective. Rooftop pool parties, activities with local organizations, and impromptu communal meals are all great ways to connect with fellow residents.',
		imageDescription10:
			'Social interaction is not confined to physical space. Online community plays a significant part in how we grow our personal networks.',
		imageDescription11:
			'A magazine library, movie nights, and pool parties. Our community center is a hub for connecting and sharing.',
		imageDescription12:
			'We hope you will experience the most rewarding and meaningful relationships of your lifetime.',
		community: 'community of coliving',
	},
	sitemap: {
		sitemap: 'Sitemap',
		member: 'Member',
		checkin: 'Choose Your Room',
		ninthfloor: 'Ninthfloor',
		service: 'Service',
		journal: 'Journal',
		help: 'Help',
		login: 'Login',
		filter: 'Fliter',
		area: 'Area',
		pauian: 'Pure Co-living',
		personalized: 'Personalized',
		about: 'About',
		media: 'Media',
		team: 'Team',
		contact: 'Contact',
		space: 'Space',
		coliving: 'Coliving',
		how: 'How to Apply',
		FAQ: 'FAQ',
		contactUs: 'Contact Us',
		termsofService: 'Terms of Service',
		privacy: 'Privacy Policy',
	},
	BookingInsto: {
		paymentDescription: 'Financial Withholding and Refund Policy',
		paymentItem1:
			'9floor use NewebPay as the payment platform. NewebPay is compatible with VISA, Mastercard, and JCB credit and debit cards.',
		paymentItem2:
			'1. After setup is complete, your account will be automatically debited every month. If necessary, you can check your transaction history at any time via the member page.',
		paymentItem3: '2. Monthly rent deduction will occur on your lease start date.',
		paymentItem4:
			'3. Other than the initial deposit, we will not place any advance holds on your account.',
		paymentItem5: '4. If necessary, you have the option to change your preferred account.',
		paymentItem6:
			'5. If you use an international (non-Taiwanese) card, your transaction may be subject to exchange and service fees. Check with the account provider for details.',
		agree: 'I understand and agree to the payment terms:',
		cardDetail: 'Credit/Debit Card Information',
		cardNumber: 'Card Number',
		dateline: 'Expiration Date',
		zipCode: 'Security Code',
		name: 'Name',
		continue: 'Continue to Payment',
		back: 'Go Back',
	},
	SocialSelectGroup: {
		otherSocialMedia: 'Link Other Social Media',
		linkSocialMedia: 'Social Media Link ',
		choiceSocialMedia: 'Choice',
		addLinkofSocialMedia: 'Add Link of Social Media',
	},
	MemberBadge: {
		REGISTERED: 'Registered',
		MEMBERSHIP_UNDER_REVIEW: 'Membership Under Review',
		MEMBERSHIP_DENIED: 'Membership Denied',
		BASIC_MEMBER: 'Basic Member',
		CERTIFIED_MEMBER: 'Certified Member',
		RESIDENT_MEMBER: 'Resident Member',
		BLOCKED: 'Blocked',
	},
	CoLivingSlider: {
		search: 'Search',
		serviceDetail: 'More Info',
	},
	CoLivingSection: {
		search: 'Search',
		serviceDetail: 'More Info',
		sectionTitle1: 'Urban Lifestyle',
		sectionDetail1:
			'The warm atmosphere of home with the internet access and communal workspace of a coffee shop. We curate thoughtful environments that offer a much-needed respite from the bustle of the city. Take your time sipping your morning coffee. Share a bottle of wine with your new neighbor as you unwind from the workday. Bring comfort and beauty back into your everyday routine.',
		sectionTitle2: 'Flexible Convenience',
		sectionDetail2:
			'With automated bill pay, you no longer need to remember to pay your rent. A single online bill takes care of all expenses. If you are an intern, exchange student, or working on a short-term project, our one-month minimum frees you from the confines of a long lease.',
		sectionTitle3: 'Daily Support ',
		sectionDetail3:
			'Weekly common area cleanings and garbage disposal save your precious time. Online maintenance requests minimize inconvenience and ensure quick issue resolution.',
		sectionTitle4: 'Communal Life',
		sectionDetail4:
			'Our personal experiences may be limited, but the diverse community of coliving is a jumping off point for exploring new ideas and expanding your perspective. Rooftop pool parties, activities with local organizations, and impromptu communal meals are all great ways to connect with fellow residents.',
	},
	Home: {
		qouteblock:
			'Become a part of our community. Try out the best lifestyle for today’s urban environment.',
		moreButton: 'Learn more',
	},
	LocationInfo: {
		roommate: 'Roommates',
	},
	RoomCard: {
		month: 'month',
	},
	breadcrumb: {
		moveIn: 'Move-in',
		roomSearch: 'Room Search',
		geographicSearch: 'Geographic Search',
		home: '9floor',
		about: 'About',
		media: 'Media',
		team: 'Team',
		contact: 'Contact',
		service: 'Service',
		spaceManagement: 'Space Management',
		coliving: 'Coliving',
		member: 'Member',
		overview: 'Overview',
		add: 'Member Settings',
		settings: 'Member Settings',
		favorites: 'Wishlist',
		propertyViewingHistory: 'Appointment Record',
		reservationHistory: 'Booking History',
		onlineCommunity: 'Community',
		termsOfService: 'Terms',
		description: 'Description',
		privacyPolicy: 'Privacy Policy',
		sitemap: 'Sitemap',
		room: 'Room',
		booking: 'Booking',
		user: 'User',
		reservation: 'Reservation',
		renewYourLease: 'Renew Your Lease',
		book: 'Booking History',
		appointment: 'Appointment',
		checkin: 'Schedule a Move-in Appointment',
		checkout: 'Schedule a Checkout Appointment',
		cancel: 'Cancel',
		changeAppointment: 'Change an Appointment',
		interview: 'Interview',
	},
	cookie: {
		title: 'We use cookie',
		description:
			'This website uses cookies. By continuing to use this site you are agreeing to our use of cookies. For more info, including how to adjust your settings, please view our',
		policy: 'Cookie Policy',
		buttonText: 'Agree',
	},
	community: {
		qouteblock:
			'Become a part of our community. Try out the best lifestyle for today’s urban environment.',
		moreButton: 'Learn more',
		communitySearch:
			'Our personal experiences may be limited, but the diverse community of coliving is a jumping off point for exploring new ideas and expanding your perspective. No matter your background, we hope that 9floor will be a place where you can find community and a sense of belonging.',
		selectCity: 'City',
		placeholder: 'Hobby (e.g., Basketball, Design, Book Club )',
		findbutton: 'Find Someone',
		communityAlert: 'This service is exclusive for Resident Member.',
	},
	previewSection: {
		review: 'Application Under Review',
		reviewDetail:
			'After we receive your application, our staff requires 2-3 working days to review the information (weekends and national holidays excluded). Thank you for your patience.',
	},
	reservationCancel: {
		confirm: 'Confirm Your Cancellation',
		reason: 'Reason for Cancellation',
		AboutToCancel: 'You are about to cancel the appointment.',
		cancelAlert:
			'Are you sure you would like to cancel your appointment? After canceling, your monthly allowance of property viewings will not be updated. You still have {{number}} remaining property viewings for this month.',
		cancellation: 'Confirm Cancellation',
	},
	songList: {
		song: "What's the name of the song?",
		addSong: 'Add',
	},
	roommateDetail: {
		favoriteSong: 'Favorite Song',
		communityLink: 'Community Link',
		more: 'More',
	},
};



// WEBPACK FOOTER //
// ./src/util/resources/en.js